import * as React from 'react';

//  new saved project design for mobile view ports
export const SavedProject = () => (
    <div className="hide-on-desktop saved-project-section">
        <span>SEE YOUR SAVED PROJECTS</span>
        <br />
        <div className="btn">
            <a className="uig-button uig-secondary-button" href="/mySavedProjects/?filterProjectCategory=1_CALENDARS">
                    MY PROJECTS
            </a>
        </div>
        <div className="h-line" />
    </div>
);

// visit on desktop section - mobile specific
export const VisitOnDesktop = () => (
    <div className="hide-on-desktop visit-on-desktop-section">
        <div className="h-line" />
        <span>For even more customization options,
               visit Shutterfly.com on your desktop</span>
        <div className="h-line" />
    </div>
);
